import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: `Voting {processedVote} for Proposal {proposalId} with {balance}`,
  boxTitle: 'Vote',
  boxDescription: 'Please submit to vote',
  rowTitle: 'Casting vote',
  rowYes: 'YAE',
  rowNo: 'NAY',
  pageTitle: `Voting for Proposal`,
  missingParamTitle: 'Invalid vote',
  missingParam: 'Invalid field for {missingField}.',
  errorVoteBalance: 'Invalid balance',
});
